import { render } from "./EditorPageListing.vue?vue&type=template&id=dc6b9ffc&scoped=true"
import script from "./EditorPageListing.vue?vue&type=script&lang=js"
export * from "./EditorPageListing.vue?vue&type=script&lang=js"

import "./EditorPageListing.vue?vue&type=style&index=0&id=dc6b9ffc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6b9ffc"]])

export default __exports__